// @ts-nocheck
export const localeCodes =  [
  "en",
  "fr",
  "nl",
  "de",
  "es",
  "it",
  "pl",
  "ko",
  "uk"
]
export const localeLoaders = {
  en: [
    {
      key: "locale_en_46json_2321b27c",
      load: () => import("#nuxt-i18n/2321b27c" /* webpackChunkName: "locale_en_46json_2321b27c" */),
      cache: true
    },
    {
      key: "locale_en_46json_eec68424",
      load: () => import("#nuxt-i18n/eec68424" /* webpackChunkName: "locale_en_46json_eec68424" */),
      cache: true
    },
    {
      key: "locale_en_46json_dfcc28ca",
      load: () => import("#nuxt-i18n/dfcc28ca" /* webpackChunkName: "locale_en_46json_dfcc28ca" */),
      cache: true
    },
    {
      key: "locale_en_46json_3518bf19",
      load: () => import("#nuxt-i18n/3518bf19" /* webpackChunkName: "locale_en_46json_3518bf19" */),
      cache: true
    },
    {
      key: "locale_en_46json_92700fe4",
      load: () => import("#nuxt-i18n/92700fe4" /* webpackChunkName: "locale_en_46json_92700fe4" */),
      cache: true
    },
    {
      key: "locale_en_46json_ba969174",
      load: () => import("#nuxt-i18n/ba969174" /* webpackChunkName: "locale_en_46json_ba969174" */),
      cache: true
    },
    {
      key: "locale_en_46json_db72392a",
      load: () => import("#nuxt-i18n/db72392a" /* webpackChunkName: "locale_en_46json_db72392a" */),
      cache: true
    },
    {
      key: "locale_en_46json_b4ef117d",
      load: () => import("#nuxt-i18n/b4ef117d" /* webpackChunkName: "locale_en_46json_b4ef117d" */),
      cache: true
    },
    {
      key: "locale_en_46json_ec4105be",
      load: () => import("#nuxt-i18n/ec4105be" /* webpackChunkName: "locale_en_46json_ec4105be" */),
      cache: true
    }
  ],
  fr: [
    {
      key: "locale_fr_46json_86c442ce",
      load: () => import("#nuxt-i18n/86c442ce" /* webpackChunkName: "locale_fr_46json_86c442ce" */),
      cache: true
    },
    {
      key: "locale_fr_46json_6af887d5",
      load: () => import("#nuxt-i18n/6af887d5" /* webpackChunkName: "locale_fr_46json_6af887d5" */),
      cache: true
    },
    {
      key: "locale_fr_46json_15336c90",
      load: () => import("#nuxt-i18n/15336c90" /* webpackChunkName: "locale_fr_46json_15336c90" */),
      cache: true
    },
    {
      key: "locale_fr_46json_47971bad",
      load: () => import("#nuxt-i18n/47971bad" /* webpackChunkName: "locale_fr_46json_47971bad" */),
      cache: true
    },
    {
      key: "locale_fr_46json_b4805051",
      load: () => import("#nuxt-i18n/b4805051" /* webpackChunkName: "locale_fr_46json_b4805051" */),
      cache: true
    },
    {
      key: "locale_fr_46json_735715e4",
      load: () => import("#nuxt-i18n/735715e4" /* webpackChunkName: "locale_fr_46json_735715e4" */),
      cache: true
    },
    {
      key: "locale_fr_46json_3d2db2d9",
      load: () => import("#nuxt-i18n/3d2db2d9" /* webpackChunkName: "locale_fr_46json_3d2db2d9" */),
      cache: true
    },
    {
      key: "locale_fr_46json_e7ad816c",
      load: () => import("#nuxt-i18n/e7ad816c" /* webpackChunkName: "locale_fr_46json_e7ad816c" */),
      cache: true
    },
    {
      key: "locale_fr_46json_2c5ef3f4",
      load: () => import("#nuxt-i18n/2c5ef3f4" /* webpackChunkName: "locale_fr_46json_2c5ef3f4" */),
      cache: true
    }
  ],
  nl: [
    {
      key: "locale_nl_46json_708625a1",
      load: () => import("#nuxt-i18n/708625a1" /* webpackChunkName: "locale_nl_46json_708625a1" */),
      cache: true
    },
    {
      key: "locale_nl_46json_02b5803d",
      load: () => import("#nuxt-i18n/02b5803d" /* webpackChunkName: "locale_nl_46json_02b5803d" */),
      cache: true
    },
    {
      key: "locale_nl_46json_4fe2831d",
      load: () => import("#nuxt-i18n/4fe2831d" /* webpackChunkName: "locale_nl_46json_4fe2831d" */),
      cache: true
    },
    {
      key: "locale_nl_46json_a0f6ed0f",
      load: () => import("#nuxt-i18n/a0f6ed0f" /* webpackChunkName: "locale_nl_46json_a0f6ed0f" */),
      cache: true
    },
    {
      key: "locale_nl_46json_d9c0d992",
      load: () => import("#nuxt-i18n/d9c0d992" /* webpackChunkName: "locale_nl_46json_d9c0d992" */),
      cache: true
    },
    {
      key: "locale_nl_46json_56119ad8",
      load: () => import("#nuxt-i18n/56119ad8" /* webpackChunkName: "locale_nl_46json_56119ad8" */),
      cache: true
    },
    {
      key: "locale_nl_46json_2b82864a",
      load: () => import("#nuxt-i18n/2b82864a" /* webpackChunkName: "locale_nl_46json_2b82864a" */),
      cache: true
    },
    {
      key: "locale_nl_46json_a89c1175",
      load: () => import("#nuxt-i18n/a89c1175" /* webpackChunkName: "locale_nl_46json_a89c1175" */),
      cache: true
    },
    {
      key: "locale_nl_46json_a0f424fc",
      load: () => import("#nuxt-i18n/a0f424fc" /* webpackChunkName: "locale_nl_46json_a0f424fc" */),
      cache: true
    }
  ],
  de: [
    {
      key: "locale_de_46json_ee1ac1a9",
      load: () => import("#nuxt-i18n/ee1ac1a9" /* webpackChunkName: "locale_de_46json_ee1ac1a9" */),
      cache: true
    },
    {
      key: "locale_de_46json_5d3ad2b0",
      load: () => import("#nuxt-i18n/5d3ad2b0" /* webpackChunkName: "locale_de_46json_5d3ad2b0" */),
      cache: true
    },
    {
      key: "locale_de_46json_b6f26072",
      load: () => import("#nuxt-i18n/b6f26072" /* webpackChunkName: "locale_de_46json_b6f26072" */),
      cache: true
    },
    {
      key: "locale_de_46json_518e89aa",
      load: () => import("#nuxt-i18n/518e89aa" /* webpackChunkName: "locale_de_46json_518e89aa" */),
      cache: true
    },
    {
      key: "locale_de_46json_39288ea4",
      load: () => import("#nuxt-i18n/39288ea4" /* webpackChunkName: "locale_de_46json_39288ea4" */),
      cache: true
    },
    {
      key: "locale_de_46json_c98ce7ea",
      load: () => import("#nuxt-i18n/c98ce7ea" /* webpackChunkName: "locale_de_46json_c98ce7ea" */),
      cache: true
    },
    {
      key: "locale_de_46json_5e0b0978",
      load: () => import("#nuxt-i18n/5e0b0978" /* webpackChunkName: "locale_de_46json_5e0b0978" */),
      cache: true
    },
    {
      key: "locale_de_46json_5baaea47",
      load: () => import("#nuxt-i18n/5baaea47" /* webpackChunkName: "locale_de_46json_5baaea47" */),
      cache: true
    },
    {
      key: "locale_de_46json_649cce2b",
      load: () => import("#nuxt-i18n/649cce2b" /* webpackChunkName: "locale_de_46json_649cce2b" */),
      cache: true
    }
  ],
  es: [
    {
      key: "locale_es_46json_839e8235",
      load: () => import("#nuxt-i18n/839e8235" /* webpackChunkName: "locale_es_46json_839e8235" */),
      cache: true
    },
    {
      key: "locale_es_46json_1b0a2c27",
      load: () => import("#nuxt-i18n/1b0a2c27" /* webpackChunkName: "locale_es_46json_1b0a2c27" */),
      cache: true
    },
    {
      key: "locale_es_46json_b4cb33fe",
      load: () => import("#nuxt-i18n/b4cb33fe" /* webpackChunkName: "locale_es_46json_b4cb33fe" */),
      cache: true
    },
    {
      key: "locale_es_46json_064d58c2",
      load: () => import("#nuxt-i18n/064d58c2" /* webpackChunkName: "locale_es_46json_064d58c2" */),
      cache: true
    },
    {
      key: "locale_es_46json_e3df2771",
      load: () => import("#nuxt-i18n/e3df2771" /* webpackChunkName: "locale_es_46json_e3df2771" */),
      cache: true
    },
    {
      key: "locale_es_46json_63657471",
      load: () => import("#nuxt-i18n/63657471" /* webpackChunkName: "locale_es_46json_63657471" */),
      cache: true
    },
    {
      key: "locale_es_46json_3f514de4",
      load: () => import("#nuxt-i18n/3f514de4" /* webpackChunkName: "locale_es_46json_3f514de4" */),
      cache: true
    },
    {
      key: "locale_es_46json_082014e2",
      load: () => import("#nuxt-i18n/082014e2" /* webpackChunkName: "locale_es_46json_082014e2" */),
      cache: true
    },
    {
      key: "locale_es_46json_ac3b0785",
      load: () => import("#nuxt-i18n/ac3b0785" /* webpackChunkName: "locale_es_46json_ac3b0785" */),
      cache: true
    }
  ],
  it: [
    {
      key: "locale_it_46json_ff564233",
      load: () => import("#nuxt-i18n/ff564233" /* webpackChunkName: "locale_it_46json_ff564233" */),
      cache: true
    },
    {
      key: "locale_it_46json_e9e69868",
      load: () => import("#nuxt-i18n/e9e69868" /* webpackChunkName: "locale_it_46json_e9e69868" */),
      cache: true
    },
    {
      key: "locale_it_46json_8f129204",
      load: () => import("#nuxt-i18n/8f129204" /* webpackChunkName: "locale_it_46json_8f129204" */),
      cache: true
    },
    {
      key: "locale_it_46json_96aaf4dc",
      load: () => import("#nuxt-i18n/96aaf4dc" /* webpackChunkName: "locale_it_46json_96aaf4dc" */),
      cache: true
    },
    {
      key: "locale_it_46json_c90c02fa",
      load: () => import("#nuxt-i18n/c90c02fa" /* webpackChunkName: "locale_it_46json_c90c02fa" */),
      cache: true
    },
    {
      key: "locale_it_46json_ef327b08",
      load: () => import("#nuxt-i18n/ef327b08" /* webpackChunkName: "locale_it_46json_ef327b08" */),
      cache: true
    },
    {
      key: "locale_it_46json_25451059",
      load: () => import("#nuxt-i18n/25451059" /* webpackChunkName: "locale_it_46json_25451059" */),
      cache: true
    },
    {
      key: "locale_it_46json_44b5f622",
      load: () => import("#nuxt-i18n/44b5f622" /* webpackChunkName: "locale_it_46json_44b5f622" */),
      cache: true
    },
    {
      key: "locale_it_46json_248c78e4",
      load: () => import("#nuxt-i18n/248c78e4" /* webpackChunkName: "locale_it_46json_248c78e4" */),
      cache: true
    }
  ],
  pl: [
    {
      key: "locale_pl_46json_dcfbfaff",
      load: () => import("#nuxt-i18n/dcfbfaff" /* webpackChunkName: "locale_pl_46json_dcfbfaff" */),
      cache: true
    },
    {
      key: "locale_pl_46json_706f8331",
      load: () => import("#nuxt-i18n/706f8331" /* webpackChunkName: "locale_pl_46json_706f8331" */),
      cache: true
    },
    {
      key: "locale_pl_46json_2ff7b6f7",
      load: () => import("#nuxt-i18n/2ff7b6f7" /* webpackChunkName: "locale_pl_46json_2ff7b6f7" */),
      cache: true
    },
    {
      key: "locale_pl_46json_6c77c317",
      load: () => import("#nuxt-i18n/6c77c317" /* webpackChunkName: "locale_pl_46json_6c77c317" */),
      cache: true
    },
    {
      key: "locale_pl_46json_dba3e4e1",
      load: () => import("#nuxt-i18n/dba3e4e1" /* webpackChunkName: "locale_pl_46json_dba3e4e1" */),
      cache: true
    },
    {
      key: "locale_pl_46json_d0c79c77",
      load: () => import("#nuxt-i18n/d0c79c77" /* webpackChunkName: "locale_pl_46json_d0c79c77" */),
      cache: true
    },
    {
      key: "locale_pl_46json_64fc6461",
      load: () => import("#nuxt-i18n/64fc6461" /* webpackChunkName: "locale_pl_46json_64fc6461" */),
      cache: true
    },
    {
      key: "locale_pl_46json_7ec25c22",
      load: () => import("#nuxt-i18n/7ec25c22" /* webpackChunkName: "locale_pl_46json_7ec25c22" */),
      cache: true
    },
    {
      key: "locale_pl_46json_96f40b31",
      load: () => import("#nuxt-i18n/96f40b31" /* webpackChunkName: "locale_pl_46json_96f40b31" */),
      cache: true
    }
  ],
  ko: [
    {
      key: "locale_ko_46json_42fe1326",
      load: () => import("#nuxt-i18n/42fe1326" /* webpackChunkName: "locale_ko_46json_42fe1326" */),
      cache: true
    },
    {
      key: "locale_ko_46json_b93bec73",
      load: () => import("#nuxt-i18n/b93bec73" /* webpackChunkName: "locale_ko_46json_b93bec73" */),
      cache: true
    },
    {
      key: "locale_ko_46json_7dece906",
      load: () => import("#nuxt-i18n/7dece906" /* webpackChunkName: "locale_ko_46json_7dece906" */),
      cache: true
    },
    {
      key: "locale_ko_46json_b61354a5",
      load: () => import("#nuxt-i18n/b61354a5" /* webpackChunkName: "locale_ko_46json_b61354a5" */),
      cache: true
    },
    {
      key: "locale_ko_46json_e9b5e0c5",
      load: () => import("#nuxt-i18n/e9b5e0c5" /* webpackChunkName: "locale_ko_46json_e9b5e0c5" */),
      cache: true
    },
    {
      key: "locale_ko_46json_152a4c5d",
      load: () => import("#nuxt-i18n/152a4c5d" /* webpackChunkName: "locale_ko_46json_152a4c5d" */),
      cache: true
    },
    {
      key: "locale_ko_46json_13170ea5",
      load: () => import("#nuxt-i18n/13170ea5" /* webpackChunkName: "locale_ko_46json_13170ea5" */),
      cache: true
    },
    {
      key: "locale_ko_46json_48c178ea",
      load: () => import("#nuxt-i18n/48c178ea" /* webpackChunkName: "locale_ko_46json_48c178ea" */),
      cache: true
    },
    {
      key: "locale_ko_46json_45058380",
      load: () => import("#nuxt-i18n/45058380" /* webpackChunkName: "locale_ko_46json_45058380" */),
      cache: true
    }
  ],
  uk: [
    {
      key: "locale_uk_46json_ca416d95",
      load: () => import("#nuxt-i18n/ca416d95" /* webpackChunkName: "locale_uk_46json_ca416d95" */),
      cache: true
    },
    {
      key: "locale_uk_46json_76e1b06a",
      load: () => import("#nuxt-i18n/76e1b06a" /* webpackChunkName: "locale_uk_46json_76e1b06a" */),
      cache: true
    },
    {
      key: "locale_uk_46json_2a78b593",
      load: () => import("#nuxt-i18n/2a78b593" /* webpackChunkName: "locale_uk_46json_2a78b593" */),
      cache: true
    },
    {
      key: "locale_uk_46json_f3c353ac",
      load: () => import("#nuxt-i18n/f3c353ac" /* webpackChunkName: "locale_uk_46json_f3c353ac" */),
      cache: true
    },
    {
      key: "locale_uk_46json_68f81273",
      load: () => import("#nuxt-i18n/68f81273" /* webpackChunkName: "locale_uk_46json_68f81273" */),
      cache: true
    },
    {
      key: "locale_uk_46json_556f87de",
      load: () => import("#nuxt-i18n/556f87de" /* webpackChunkName: "locale_uk_46json_556f87de" */),
      cache: true
    },
    {
      key: "locale_uk_46json_e85e465e",
      load: () => import("#nuxt-i18n/e85e465e" /* webpackChunkName: "locale_uk_46json_e85e465e" */),
      cache: true
    },
    {
      key: "locale_uk_46json_28a9bb41",
      load: () => import("#nuxt-i18n/28a9bb41" /* webpackChunkName: "locale_uk_46json_28a9bb41" */),
      cache: true
    },
    {
      key: "locale_uk_46json_560bfeaf",
      load: () => import("#nuxt-i18n/560bfeaf" /* webpackChunkName: "locale_uk_46json_560bfeaf" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    code: "en",
    name: "English",
    language: undefined
  },
  {
    code: "fr",
    name: "Français",
    language: undefined
  },
  {
    code: "nl",
    name: "Nederlands",
    language: undefined
  },
  {
    code: "de",
    name: "Deutsch",
    language: undefined
  },
  {
    code: "es",
    name: "Español",
    language: undefined
  },
  {
    code: "it",
    name: "Italiano",
    language: undefined
  },
  {
    code: "pl",
    name: "Polski (Beta)",
    language: undefined
  },
  {
    code: "ko",
    name: "한국어",
    language: undefined
  },
  {
    code: "uk",
    name: "Українська",
    language: undefined
  }
]
/** client **/

/** client-end **/